export const SHOW_MODAL = {
  success: 'SHOW_MODAL_SUCCESS',
};

export const HIDE_MODAL = {
  success: 'HIDE_MODAL_SUCCESS',
};

const defaultModalData = {
  title: '',
  description: '',
  focusAchievementId: null,
};

/**
 * @param {string} [modal]
 * @param {Record<string, unknown>} [modalData]
 */
export const showModal = (modal = 'MODAL_SIGNUP', modalData = defaultModalData) => ({
  type: SHOW_MODAL.success,
  payload: {
    modal,
    modalData: {
      ...defaultModalData,
      ...modalData,
    },
  },
});

export const hideModal = () => ({
  type: HIDE_MODAL.success,
});
